export default __webpack_public_path__ + "static/media/loader.2d728c0c.gif";